import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en/translation.json';
import kr from './kr/translation.json';
import vi from './vi/translation.json';
let browserLang = navigator.language || navigator.userLanguage;
console.log(browserLang);

const urlParams = new URLSearchParams(window.location.search);
const key = 'lang';
const lang = urlParams.get(key);

// Initialize the default language as 'en'
let selectedLang = 'en';

if (lang) {
    sessionStorage.setItem(key, lang);
    if (sessionStorage.getItem(key)) {
        browserLang = sessionStorage.getItem(key);
    }
} else {
    // user select language
    // Check if a language is stored in sessionStorage
    const storedLang = sessionStorage.getItem('lang');
    if (storedLang) {
        selectedLang = storedLang;
    }
}

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: en
            },
            ko: {
                translation: kr
            },
            vi: {
                translation: vi
            }
        },
        // lng: browserLang.substr(0, 2), // if you're using a language detector, do not define the lng option
        lng: lang ? browserLang.substr(0, 2) : selectedLang, // if you're using a language detector, do not define the lng option
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });

export function changeLanguage(language) {
    i18n.changeLanguage(language);
    sessionStorage.setItem('lang', language);
}
